
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_91view_93_93kGI3tmoDms2Ah3hvX2DSeXWSC2o0q2FObphin3L_h_45YMeta } from "/frontend/pages/[[view]].vue?macro=true";
import { default as settingstLztCMKy78DwnleYxc6mpqvCfyFbDPt8ndv2hIUobasMeta } from "/frontend/pages/settings.vue?macro=true";
import { default as _91id_93F35HEDmez2g6JguwBkVyDne_45Zp9ZvMH3UsAOoBb3rUQMeta } from "/frontend/pages/tasks/[id].vue?macro=true";
import { default as timesheetsh_45eneRvk0ssGgccX4K8BIP4UJflrf05WUpiCmmNPwpIMeta } from "/frontend/pages/timesheets.vue?macro=true";
import { default as indexWZOIDJ2rJPgIvDyya9UBegr_45AP_641hcdoKYUSmEn2gMeta } from "/frontend/pages/clients/index.vue?macro=true";
import { default as indexybxMtRvgc4blByyIdhY26KUb0hxd7_45pbTZXldv7l_45ycMeta } from "/frontend/pages/reports/index.vue?macro=true";
import { default as indexdpZq2iR5iArSwprRNFc4N7K4IukkBwZEgPvFI7YiYroMeta } from "/frontend/pages/invoices/index.vue?macro=true";
import { default as index6NFek8EOoZVRb6FGD7WN2e6HF51LJayBmSuadU9G280Meta } from "/frontend/pages/projects/index.vue?macro=true";
import { default as _91id_93Usbq6bNPQDJYFkSH0_C1LaxK0zrR4Uh5_ZY_45UNMAXdkMeta } from "/frontend/pages/task-lists/[id].vue?macro=true";
import { default as indexcgSxjvtyZ8H7v_d8_45DKmAJS7P7p1CKc0ppYmN1kPzr4Meta } from "/frontend/pages/scheduling/index.vue?macro=true";
import { default as _91view_93IUW53v4AbicXNAkBu2Uye8rcJgaMxTILGfW3LnvOB4QMeta } from "/frontend/pages/clients/[id]/[view].vue?macro=true";
import { default as _91view_93ER27sCUZ4OWVqKNwDeypQQs3BPQ1PO99rxBKbFhOvhQMeta } from "/frontend/pages/reports/[id]/[view].vue?macro=true";
import { default as _91view_9378tju5SJwj04phWlZRCIWeregTwuf_45JGrcl51maWEzAMeta } from "/frontend/pages/projects/[id]/[view].vue?macro=true";
import { default as indexV4sbOffPqnIrhnm5jEkln58IQYI4mH7yktJu24vkuZYMeta } from "/frontend/pages/recurring-invoices/index.vue?macro=true";
export default [
  {
    name: "dashboard",
    path: "/:view?",
    meta: _91_91view_93_93kGI3tmoDms2Ah3hvX2DSeXWSC2o0q2FObphin3L_h_45YMeta || {},
    component: () => import("/frontend/pages/[[view]].vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingstLztCMKy78DwnleYxc6mpqvCfyFbDPt8ndv2hIUobasMeta || {},
    component: () => import("/frontend/pages/settings.vue")
  },
  {
    name: "tasks-id",
    path: "/tasks/:id()",
    component: () => import("/frontend/pages/tasks/[id].vue")
  },
  {
    name: "timesheets",
    path: "/timesheets",
    meta: timesheetsh_45eneRvk0ssGgccX4K8BIP4UJflrf05WUpiCmmNPwpIMeta || {},
    component: () => import("/frontend/pages/timesheets.vue")
  },
  {
    name: "clients",
    path: "/clients",
    component: () => import("/frontend/pages/clients/index.vue")
  },
  {
    name: "reports",
    path: "/reports",
    meta: indexybxMtRvgc4blByyIdhY26KUb0hxd7_45pbTZXldv7l_45ycMeta || {},
    component: () => import("/frontend/pages/reports/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: indexdpZq2iR5iArSwprRNFc4N7K4IukkBwZEgPvFI7YiYroMeta || {},
    component: () => import("/frontend/pages/invoices/index.vue")
  },
  {
    name: "projects",
    path: "/projects",
    meta: index6NFek8EOoZVRb6FGD7WN2e6HF51LJayBmSuadU9G280Meta || {},
    component: () => import("/frontend/pages/projects/index.vue")
  },
  {
    name: "task-lists-id",
    path: "/task-lists/:id()",
    component: () => import("/frontend/pages/task-lists/[id].vue")
  },
  {
    name: "scheduling",
    path: "/scheduling",
    component: () => import("/frontend/pages/scheduling/index.vue")
  },
  {
    name: "clients-id-view",
    path: "/clients/:id()/:view()",
    meta: _91view_93IUW53v4AbicXNAkBu2Uye8rcJgaMxTILGfW3LnvOB4QMeta || {},
    component: () => import("/frontend/pages/clients/[id]/[view].vue")
  },
  {
    name: "reports-id-view",
    path: "/reports/:id()/:view()",
    meta: _91view_93ER27sCUZ4OWVqKNwDeypQQs3BPQ1PO99rxBKbFhOvhQMeta || {},
    component: () => import("/frontend/pages/reports/[id]/[view].vue")
  },
  {
    name: "projects-id-view",
    path: "/projects/:id()/:view()",
    meta: _91view_9378tju5SJwj04phWlZRCIWeregTwuf_45JGrcl51maWEzAMeta || {},
    component: () => import("/frontend/pages/projects/[id]/[view].vue")
  },
  {
    name: "recurring-invoices",
    path: "/recurring-invoices",
    meta: indexV4sbOffPqnIrhnm5jEkln58IQYI4mH7yktJu24vkuZYMeta || {},
    component: () => import("/frontend/pages/recurring-invoices/index.vue")
  }
]